module.exports = __webpack_public_path__ + "img/logo.98ef9ec7.png";